import { Loader2 } from "lucide-react";
import { Dialog } from "@/components/ui/dialog";
import { MediaLightbox } from "@/components/MediaLightbox";
import { useAssetIdUrl, useAssetUrl } from "@/hooks/useAssetUrl";
import type { AssetType } from "@/lib/api";

export interface ReferencePreviewTarget {
  assetId?: string;
  storageKey?: string;
  label: string;
  type?: AssetType;
}

/** Resolve the original through the existing authorized media exchange. */
export function ReferenceLightbox({ target, onClose }: { target: ReferencePreviewTarget; onClose: () => void }) {
  const byId = useAssetIdUrl(target.assetId);
  const byKey = useAssetUrl(!target.assetId ? target.storageKey : null);
  const { url, error } = target.assetId ? byId : byKey;
  if (!url) return <Dialog open onClose={onClose} title={target.label}>
    <div role="status" className="p-6 text-sm text-studio-muted">
      {error ? "This reference is unavailable or you no longer have access." : <span className="flex items-center gap-2"><Loader2 className="h-4 w-4 animate-spin" /> Opening reference…</span>}
    </div>
  </Dialog>;
  return <MediaLightbox open onClose={onClose} url={url} type={target.type ?? "image"} alt={target.label} />;
}
